import { IWebsiteBuilderTable, TWebsiteBuilderTableCell, TWebsiteBuilderTableRow, websiteBuilderGenerateTableCellDesignStyles, websiteBuilderGenerateTableDesignStyles, websiteBuilderGenerateTableRowDesignStyles } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderTable";
import { IWebsiteBuilderSectionEntityViewBoundingBox } from "../../../hooks/sectionEntity/helpers/sectionEntityViewBoundingBox";
import { useAppSelector } from "hooks/redux";
import React, { Fragment } from "react";
import { TableBuilder } from "pages/secure/facility/websiteBuilder/editor/tableBuilder/TableBuilder";
import classNames from "classnames";
import { websiteBuilderFindIconAsset, WEBSITE_BUILDER_MISSING_ICON_ASSET_SVG } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderIcon";

interface IWebsiteBuilderTableViewProps {
  node: IWebsiteBuilderTable;
  containerBoundingBox: IWebsiteBuilderSectionEntityViewBoundingBox;
  containerBuilderUIPortalId: string;
}

export function WebsiteBuilderTableView(props: IWebsiteBuilderTableViewProps) {
  const { node, containerBoundingBox, containerBuilderUIPortalId } = props;

  const selectedNode = useAppSelector(store => store.websiteBuilderStore.editor.selectedNode);
  const iconAssets = useAppSelector(store => store.websiteBuilderStore.editor.iconAssets);

  const selected = selectedNode?.id === node.id;
  const builderActive = selected && selectedNode?.editingMode?.type === "container-builder";

  const settings = node.container.settings;
  const tableDesignStyles = websiteBuilderGenerateTableDesignStyles();

  function renderCellValue(cell: TWebsiteBuilderTableCell) {
    const cellDesignStyles = websiteBuilderGenerateTableCellDesignStyles(cell);

    if (cell.value.type === "icon") {
      const iconAsset = websiteBuilderFindIconAsset(iconAssets, cell.value.assetIdentity);

      return (
        <div
          className={classNames(cellDesignStyles.contentClassName, cellDesignStyles.iconClassName)}
          style={cellDesignStyles.iconStyleProperties}
          dangerouslySetInnerHTML={{ __html: iconAsset?.svg ?? (cell.value.assetIdentity != null ? WEBSITE_BUILDER_MISSING_ICON_ASSET_SVG : "") }}
        />
      );
    } else {
      return <div className={cellDesignStyles.contentClassName}>{cell.value.content}</div>;
    }
  }

  function renderCell(cell: TWebsiteBuilderTableCell, index: number) {
    const isHeadCell = cell.type === "head";

    const CellTag = isHeadCell ? "th" : "td";
    const mobileContentCell = isHeadCell ? null : settings.head.row.cells[index];

    const cellDesignStyles = websiteBuilderGenerateTableCellDesignStyles(cell);

    return (
      <CellTag>
        {mobileContentCell != null && (
          <div className={cellDesignStyles.mobileContentContainerClassName}>
            {renderCellValue(mobileContentCell)}
          </div>
        )}
        {renderCellValue(cell)}
      </CellTag>
    );
  }
  
  function renderRow(row: TWebsiteBuilderTableRow) {
    const rowDesignStyles = websiteBuilderGenerateTableRowDesignStyles(row);

    return (
      <tr style={rowDesignStyles.styleProperties}>
        {row.cells.map((cell, index) => <Fragment key={cell.id}>{renderCell(cell, index)}</Fragment>)}
      </tr>
    );
  }

  if (builderActive) {
    return (
      <TableBuilder
        tableNode={node}
        containerBoundingBox={containerBoundingBox}
        containerBuilderUIPortalId={containerBuilderUIPortalId}
      />
    );
  } else {
    return (
      <div className={tableDesignStyles.containerClassName}>
        <table className={tableDesignStyles.className}>
          <thead>
            {renderRow(settings.head.row)}
          </thead>
          <tbody>
            {settings.body.rows.map(row => <Fragment key={row.id}>{renderRow(row)}</Fragment>)}
          </tbody>
        </table>
      </div>
    );
  }
}